import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export function PaymentIssueBanner() {
  const { user } = useAuth();
  const a = user?.access;
  if (!a) return null;
  const own = a.payment_issue;
  const team = !own && a.group?.payment_issue && !a.group.is_owner;
  if (!own && !team) return null;
  return (
    <div className="no-print mb-6 rounded-2xl border border-red-200 bg-red-50 p-4 sm:p-5 flex flex-wrap items-center justify-between gap-3" data-testid="payment-issue-banner">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold text-red-900">{own ? "Your last payment didn't go through" : "Your team's plan has a payment problem"}</div>
          <div className="text-sm text-red-800/80">
            {own
              ? `Update your card to keep access${a.plan === "group" ? " for you and your team" : ""}. We'll retry automatically, but fixing it now avoids a lockout.`
              : `Let ${a.group.owner_name || "your team owner"} know so they can update the card before your access is paused.`}
          </div>
        </div>
      </div>
      {own && (a.payment_issue_url ? (
        <Button asChild className="rounded-full bg-red-600 hover:bg-red-700" data-testid="payment-issue-fix-button">
          <a href={a.payment_issue_url} target="_blank" rel="noopener noreferrer">Update card &amp; pay</a>
        </Button>
      ) : (
        <Button asChild variant="outline" className="rounded-full" data-testid="payment-issue-billing-link"><Link to="/billing">Go to billing</Link></Button>
      ))}
    </div>
  );
}
